import OverflowList from "./OverflowList";
import Box from "./Box.styles";
import List from "./List.styles";
import HiddenCount from "./HiddenCount.styles";
import HiddenElements from "./HiddenElements.styles";
import HiddenWrapper from "./HiddenWrapper.styles";
import { Description, Content, Layout } from "./OverflowList.styles";

// Create namespace for consistent component API
const OverflowListNamespace = Object.assign(OverflowList, {
  Box,
  List,
  HiddenCount,
  HiddenElements,
  HiddenWrapper,
  Description,
  Content,
  Layout
});

// Export the types
export * from "./OverflowList.types";

// Named export
export { OverflowListNamespace as OverflowList };

// Make sure to export the namespace type for TypeScript
export type { OverflowListProps } from "./OverflowList.types";
